import { render, staticRenderFns } from "./sensorZhouShanScreen.vue?vue&type=template&id=9816861a"
import script from "./sensorZhouShanScreen.vue?vue&type=script&lang=js"
export * from "./sensorZhouShanScreen.vue?vue&type=script&lang=js"
import style0 from "./sensorZhouShanScreen.vue?vue&type=style&index=0&id=9816861a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports